// import moment from 'moment'
// import ft from './featureToggle'

export default {
  update (VueApp, data, callback) {
    let rsvp = VueApp.$store.state.reservation
    let leg1 = rsvp.leg1
    let leg2 = rsvp.leg2

    let leg1Type = 'Curbside'
    let leg1Fee = 0
    let leg2Type = 'Curbside'
    let leg2Fee = 0

    let leg2Service = leg2.services || leg1.services

    if (leg1.isAsap || rsvp.mtech.enabled) {
      VueApp.$store.commit('reservation/setPickupType', { leg: 'leg1', type: 'Curbside', fee: 0 })
      if (rsvp.mtech.enabled) return
    }

    if (data.action && data.action === 'logout') {
      if (leg1.isAirportPickup && leg1.selectedService) {
        if (leg1.services[leg1.selectedService].meetAndGreet) {
          leg1Type = 'MeetAndGreet'
          leg1Fee = leg1.services[leg1.selectedService].pickupFee
        }
        if (leg1.services[leg1.selectedService].curbside) {
          leg1Type = 'Curbside'
          leg1Fee = 0
        }
        VueApp.$store.commit('reservation/setPickupType', { leg: 'leg1', type: leg1Type, fee: leg1Fee })
      }

      if (rsvp.isRoundtrip) {
        if (leg2.isAirportPickup && leg2.selectedService) {
          if (leg2.services[leg2.selectedService].meetAndGreet) {
            leg2Type = 'MeetAndGreet'
            leg2Fee = leg2.services[leg2.selectedService].pickupFee
          }
          if (leg2.services[leg2.selectedService].curbside) {
            leg2Type = 'Curbside'
            leg2Fee = 0
          }
          VueApp.$store.commit('reservation/setPickupType', { leg: 'leg2', type: leg2Type, fee: leg2Fee })
        }
      }
      return
    }

    if (typeof data.isUS !== 'undefined') {
      if (data.isUS) {
        if (leg1.isAirportPickup && leg1.selectedService) {
          if (!leg1.services[leg1.selectedService].curbside &&
            leg1.services[leg1.selectedService].meetAndGreet
          ) {
            leg1Type = 'MeetAndGreet'
            leg1Fee = leg1.services[leg1.selectedService].pickupFee
          }
          VueApp.$store.commit('reservation/setPickupType', { leg: 'leg1', type: leg1Type, fee: leg1Fee })
        }

        if (rsvp.isRoundtrip && leg2.isAirportPickup && leg2.selectedService) {
          if (leg2Service[leg2.selectedService] && !leg2Service[leg2.selectedService].curbside &&
            leg2Service[leg2.selectedService].meetAndGreet
          ) {
            leg2Type = 'MeetAndGreet'
            leg2Fee = leg2Service[leg2.selectedService].pickupFee
          }
          VueApp.$store.commit('reservation/setPickupType', { leg: 'leg2', type: leg2Type, fee: leg2Fee })
        }
      } else {
        if (leg1.isAirportPickup && !!leg1.selectedService) {
          // leg1Type = 'MeetAndGreet'
          // leg1Fee = leg1.services[leg1.selectedService].pickupFee
          // if (leg1.selectedService === 'shared') {
          //   leg1Type = 'Curbside'
          //   leg1Fee = 0
          // }
          leg1Type = 'Curbside'
          leg1Fee = 0
          if (leg1.services[leg1.selectedService].licenseType === 'tcp' && !leg1.isAsap) {
            leg1Type = 'MeetAndGreet'
          }
          if (leg1.services[leg1.selectedService].brandedName.indexOf('Private Van') > -1) {
            leg1Type = 'Curbside'
          }
          VueApp.$store.commit('reservation/setPickupType', { leg: 'leg1', type: leg1Type, fee: leg1Fee })
        }
        if (rsvp.isRoundtrip && leg2.isAirportPickup && !!leg2.selectedService) {
          // leg2Type = 'MeetAndGreet'
          // leg2Fee = leg2Service[leg2.selectedService].pickupFee
          // if (leg2.selectedService === 'shared') {
          //   leg2Type = 'Curbside'
          //   leg2Fee = 0
          // }
          leg2Type = 'Curbside'
          leg2Fee = 0
          if (leg1.services[leg1.selectedService].licenseType === 'tcp') {
            leg2Type = 'MeetAndGreet'
          }
          if (leg1.services[leg1.selectedService].brandedName.indexOf('Private Van') > -1) {
            leg2Type = 'Curbside'
          }
          VueApp.$store.commit('reservation/setPickupType', { leg: 'leg2', type: leg2Type, fee: leg2Fee })
        }
      }

      callback({
        action: 'mobileCCUpdate',
        isUS: data.isUS
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/pickup-type.js